// Applab theme values.

const CLASSIC_LABEL_PADDING = '2px';
const NEW_THEME_LABEL_PADDING = '2px 15px';

export const CLASSIC_TEXT_INPUT_PADDING = '5px';
const NEW_THEME_TEXT_INPUT_PADDING = '5px 15px';

export const CLASSIC_DROPDOWN_PADDING = '0 30px 0 10px';
const NEW_THEME_DROPDOWN_PADDING = '0 30px 0 15px';

export const CLASSIC_TEXT_AREA_PADDING = '5px';
const NEW_THEME_TEXT_AREA_PADDING = '5px 15px';

const STANDARD_FONT_SIZE_THEME_VALUES = {
  default: 13,
  orange: 13,
  citrus: 13,
  ketchupAndMustard: 13,
  lemonade: 13,
  forest: 13,
  watermelon: 13,
  area51: 13,
  polar: 13,
  glowInTheDark: 13,
  bubblegum: 13,
  millennial: 13,
  robot: 13,
  classic: 14,
  coralReef: 13,
  mintChip: 13,
  lavender: 13,
  cherryVanilla: 13,
  berryPatch: 13,
  cucumber: 13,
  crushedVelvet: 13,
  playtime: 13,
  underTheSea: 13,
  blueAndGold: 13,
  blueSteel: 13,
  darkscheme: 13,
  twoTone: 13,
  pastel: 13,
  peachy: 13,
};

const TEXT_INPUT_BORDER_COLOR_THEME_VALUES = {
  type: 'color',
  default: '#4D575F',
  orange: '#FFFFFF',
  citrus: '#69883D',
  ketchupAndMustard: '#FFFFFF',
  lemonade: '#193A55',
  forest: '#000000',
  watermelon: '#578B2E',
  area51: '#D8FFA7',
  polar: '#FFFFFF',
  glowInTheDark: '#FFFFFF',
  bubblegum: '#000000',
  millennial: '#FFFFFF',
  robot: '#353C42',
  classic: 'rgb(153, 153, 153)',
  coralReef: '#D75D52',
  mintChip: '#3D95A1',
  lavender: '#8875B1',
  cherryVanilla: '#A51928',
  berryPatch: '#DF6589',
  cucumber: '#209864',
  crushedVelvet: '#69396D',
  playtime: '#18BC3C',
  underTheSea: '#096A6A',
  blueAndGold: '#FFD662',
  blueSteel: '#353B51',
  darkscheme: '#B22D2D',
  twoTone: '#000000',
  pastel: '#C87FDB',
  peachy: '#DF6C06',
};

const themeValues = {
  screen: {
    backgroundColor: {
      type: 'color',
      default: '#FFFFFF',
      orange: '#FFA400',
      citrus: '#96C257',
      ketchupAndMustard: '#EB5757',
      lemonade: '#FFE049',
      forest: '#23782B',
      watermelon: '#C5E255',
      area51: '#362F49',
      polar: '#AEE2F4',
      glowInTheDark: '#7D6CA6',
      bubblegum: '#FFC3E6',
      millennial: '#FEDBD0',
      robot: '#D8E0E3',
      classic: '#FFFFFF',
      coralReef: '#5BA0ED',
      mintChip: '#5CC8D7',
      lavender: '#A189BA',
      cherryVanilla: '#FFF5F5',
      berryPatch: '#64337D',
      cucumber: '#AAEBDF',
      crushedVelvet: '#46154A',
      playtime: '#FCFF5E',
      underTheSea: '#078282',
      blueAndGold: '#00539C',
      blueSteel: '#4B526B',
      darkscheme: '#000000',
      twoTone: '#FFFFFF',
      pastel: '#89BFEC',
      peachy: '#FFBE7B',
    },
  },
  label: {
    textColor: {
      type: 'color',
      default: '#4D575F',
      orange: '#FFFFFF',
      citrus: '#F7EC60',
      ketchupAndMustard: '#FFFFFF',
      lemonade: '#5BB7E7',
      forest: '#004624',
      watermelon: '#E2F0AA',
      area51: '#D8FFA7',
      polar: '#EFFAFF',
      glowInTheDark: '#D9FFD9',
      bubblegum: '#000000',
      millennial: '#442C2E',
      robot: '#F5F5F6',
      classic: '#333333',
      coralReef: '#FDF995',
      mintChip: '#E9FCFF',
      lavender: '#5E4D83',
      cherryVanilla: '#A51928',
      berryPatch: '#3C1053',
      cucumber: '#209864',
      crushedVelvet: '#FFFFFF',
      playtime: '#FFFFFF',
      underTheSea: '#096A6A',
      blueAndGold: '#00539C',
      blueSteel: '#FFFFFF',
      darkscheme: '#FFFFFF',
      twoTone: '#000000',
      pastel: '#A065AF',
      peachy: '#DF6C06',
    },
    backgroundColor: {
      type: 'color',
      default: 'rgba(0, 0, 0, 0)',
      orange: '#4D3100',
      citrus: '#69883D',
      ketchupAndMustard: '#A53D3D',
      lemonade: 'rgba(0, 0, 0, 0)',
      forest: 'rgba(0, 0, 0, 0)',
      watermelon: '#578B2E',
      area51: '#221D30',
      polar: '#0094CA',
      glowInTheDark: '#635982',
      bubblegum: '#FFD4ED',
      millennial: '#FEEAE6',
      robot: '#80A7B9',
      classic: 'rgba(0, 0, 0, 0)',
      coralReef: '#FC766A',
      mintChip: '#4EB4C2',
      lavender: '#CCB9E1',
      cherryVanilla: '#F1E2D4',
      berryPatch: '#FFDBE6',
      cucumber: '#EFFFF9',
      crushedVelvet: '#69396D',
      playtime: '#6AA4FC',
      underTheSea: '#95DBE5',
      blueAndGold: '#D1D1D1',
      blueSteel: '#71788E',
      darkscheme: '#707070',
      twoTone: '#FFFFFF',
      pastel: '#D1F3DF',
      peachy: '#FBEFB4',
    },
    borderColor: TEXT_INPUT_BORDER_COLOR_THEME_VALUES,
    borderRadius: {
      default: 0,
      orange: 0,
      citrus: 2,
      ketchupAndMustard: 10,
      lemonade: 0,
      forest: 2,
      watermelon: 0,
      area51: 10,
      polar: 2,
      glowInTheDark: 0,
      bubblegum: 10,
      millennial: 4,
      robot: 0,
      classic: 0,
      coralReef: 10,
      mintChip: 10,
      lavender: 10,
      cherryVanilla: 25,
      berryPatch: 30,
      cucumber: 30,
      crushedVelvet: 5,
      playtime: 10,
      underTheSea: 30,
      blueAndGold: 30,
      blueSteel: 30,
      darkscheme: 30,
      twoTone: 30,
      pastel: 30,
      peachy: 30,
    },
    borderWidth: {
      default: 0,
      orange: 0,
      citrus: 0,
      ketchupAndMustard: 0,
      lemonade: 0,
      forest: 0,
      watermelon: 0,
      area51: 0,
      polar: 0,
      glowInTheDark: 0,
      bubblegum: 0,
      millennial: 0,
      robot: 0,
      classic: 0,
      coralReef: 2,
      mintChip: 2,
      lavender: 1,
      cherryVanilla: 0,
      berryPatch: 2,
      cucumber: 1,
      crushedVelvet: 1,
      playtime: 2,
      underTheSea: 2,
      blueAndGold: 2,
      blueSteel: 0,
      darkscheme: 0,
      twoTone: 0,
      pastel: 2,
      peachy: 1,
    },
    fontFamily: {
      default: 'Arial Black',
      orange: 'Arial',
      citrus: 'Georgia',
      ketchupAndMustard: 'Georgia',
      lemonade: 'Arial Black',
      forest: 'Verdana',
      watermelon: 'Georgia',
      area51: 'Trebuchet',
      polar: 'Verdana',
      glowInTheDark: 'Tahoma',
      bubblegum: 'Georgia',
      millennial: 'Arial',
      robot: 'Tahoma',
      classic: 'Arial',
      coralReef: 'Arial',
      mintChip: 'Verdana',
      lavender: 'Georgia',
      cherryVanilla: 'Trebuchet',
      berryPatch: 'Trebuchet',
      cucumber: 'Verdana',
      crushedVelvet: 'Verdana',
      playtime: 'Verdana',
      underTheSea: 'Trebuchet',
      blueAndGold: 'Trebuchet',
      blueSteel: 'Trebuchet',
      darkscheme: 'Trebuchet',
      twoTone: 'Trebuchet',
      pastel: 'Trebuchet',
      peachy: 'Verdana',
    },
    fontSize: STANDARD_FONT_SIZE_THEME_VALUES,
    padding: {
      default: NEW_THEME_LABEL_PADDING,
      orange: NEW_THEME_LABEL_PADDING,
      citrus: NEW_THEME_LABEL_PADDING,
      ketchupAndMustard: NEW_THEME_LABEL_PADDING,
      lemonade: NEW_THEME_LABEL_PADDING,
      forest: NEW_THEME_LABEL_PADDING,
      watermelon: NEW_THEME_LABEL_PADDING,
      area51: NEW_THEME_LABEL_PADDING,
      polar: NEW_THEME_LABEL_PADDING,
      glowInTheDark: NEW_THEME_LABEL_PADDING,
      bubblegum: NEW_THEME_LABEL_PADDING,
      millennial: NEW_THEME_LABEL_PADDING,
      robot: NEW_THEME_LABEL_PADDING,
      classic: CLASSIC_LABEL_PADDING,
      coralReef: NEW_THEME_LABEL_PADDING,
      mintChip: NEW_THEME_LABEL_PADDING,
      lavender: NEW_THEME_LABEL_PADDING,
      cherryVanilla: NEW_THEME_LABEL_PADDING,
      berryPatch: NEW_THEME_LABEL_PADDING,
      cucumber: NEW_THEME_LABEL_PADDING,
      crushedVelvet: NEW_THEME_LABEL_PADDING,
      playtime: NEW_THEME_LABEL_PADDING,
      underTheSea: NEW_THEME_LABEL_PADDING,
      blueAndGold: NEW_THEME_LABEL_PADDING,
      blueSteel: NEW_THEME_LABEL_PADDING,
      darkscheme: NEW_THEME_LABEL_PADDING,
      twoTone: NEW_THEME_LABEL_PADDING,
      pastel: NEW_THEME_LABEL_PADDING,
      peachy: NEW_THEME_LABEL_PADDING,
    },
  },
  textInput: {
    textColor: {
      type: 'color',
      default: '#4D575F',
      orange: '#FFFFFF',
      citrus: '#000000',
      ketchupAndMustard: '#FFFFFF',
      lemonade: '#00A8FF',
      forest: '#FFFFFF',
      watermelon: '#151F00',
      area51: '#D8FFA7',
      polar: '#442C2E',
      glowInTheDark: '#D9FFD9',
      bubblegum: '#000000',
      millennial: '#442C2E',
      robot: '#353C42',
      classic: '#000000',
      coralReef: '#5BA0ED',
      mintChip: '#E5F4F6',
      lavender: '#5E4D83',
      cherryVanilla: '#A51928',
      berryPatch: '#3C1053',
      cucumber: '#209864',
      crushedVelvet: '#FFFFFF',
      playtime: '#FFFFFF',
      underTheSea: '#096A6A',
      blueAndGold: '#00539C',
      blueSteel: '#FFFFFF',
      darkscheme: '#FFFFFF',
      twoTone: '#000000',
      pastel: '#A065AF',
      peachy: '#DF6C06',
    },
    backgroundColor: {
      type: 'color',
      default: '#F2F2F2',
      orange: '#B37300',
      citrus: '#FFFFFF',
      ketchupAndMustard: '#A53D3D',
      lemonade: '#FFFFFF',
      forest: '#004624',
      watermelon: '#E2F0AA',
      area51: '#221D30',
      polar: '#ACCFDE',
      glowInTheDark: '#4D575F',
      bubblegum: '#FFD4ED',
      millennial: '#FEDBD0',
      robot: '#FFFFFF',
      classic: '#FFFFFF',
      coralReef: '#FDF995',
      mintChip: '#4EB4C2',
      lavender: '#CCB9E1',
      cherryVanilla: '#F1E2D4',
      berryPatch: '#FFDBE6',
      cucumber: '#EFFFF9',
      crushedVelvet: '#2D0A30',
      playtime: '#3EE061',
      underTheSea: '#95DBE5',
      blueAndGold: '#D1D1D1',
      blueSteel: '#71788E',
      darkscheme: '#707070',
      twoTone: '#FFFFFF',
      pastel: '#D1F3DF',
      peachy: '#FBEFB4',
    },
    borderColor: TEXT_INPUT_BORDER_COLOR_THEME_VALUES,
    borderRadius: {
      default: 4,
      orange: 0,
      citrus: 4,
      ketchupAndMustard: 5,
      lemonade: 4,
      forest: 4,
      watermelon: 0,
      area51: 10,
      polar: 4,
      glowInTheDark: 0,
      bubblegum: 4,
      millennial: 4,
      robot: 0,
      classic: 0,
      coralReef: 10,
      mintChip: 10,
      lavender: 10,
      cherryVanilla: 5,
      berryPatch: 30,
      cucumber: 30,
      crushedVelvet: 5,
      playtime: 10,
      underTheSea: 30,
      blueAndGold: 30,
      blueSteel: 30,
      darkscheme: 30,
      twoTone: 30,
      pastel: 30,
      peachy: 30,
    },
    borderWidth: {
      default: 1,
      orange: 1,
      citrus: 1,
      ketchupAndMustard: 1,
      lemonade: 1,
      forest: 1,
      watermelon: 2,
      area51: 1,
      polar: 1,
      glowInTheDark: 1,
      bubblegum: 1,
      millennial: 2,
      robot: 1,
      classic: 1,
      coralReef: 2,
      mintChip: 2,
      lavender: 1,
      cherryVanilla: 1,
      berryPatch: 2,
      cucumber: 1,
      crushedVelvet: 1,
      playtime: 2,
      underTheSea: 2,
      blueAndGold: 2,
      blueSteel: 2,
      darkscheme: 2,
      twoTone: 1,
      pastel: 2,
      peachy: 1,
    },
    fontFamily: {
      default: 'Arial',
      orange: 'Arial',
      citrus: 'Palatino',
      ketchupAndMustard: 'Tahoma',
      lemonade: 'Arial',
      forest: 'Arial',
      watermelon: 'Georgia',
      area51: 'Trebuchet',
      polar: 'Verdana',
      glowInTheDark: 'Tahoma',
      bubblegum: 'Trebuchet',
      millennial: 'Arial',
      robot: 'Tahoma',
      classic: 'Arial',
      coralReef: 'Arial',
      mintChip: 'Verdana',
      lavender: 'Georgia',
      cherryVanilla: 'Trebuchet',
      berryPatch: 'Trebuchet',
      cucumber: 'Verdana',
      crushedVelvet: 'Verdana',
      playtime: 'Verdana',
      underTheSea: 'Trebuchet',
      blueAndGold: 'Trebuchet',
      blueSteel: 'Trebuchet',
      darkscheme: 'Trebuchet',
      twoTone: 'Trebuchet',
      pastel: 'Trebuchet',
      peachy: 'Verdana',
    },
    fontSize: STANDARD_FONT_SIZE_THEME_VALUES,
    padding: {
      default: NEW_THEME_TEXT_INPUT_PADDING,
      orange: NEW_THEME_TEXT_INPUT_PADDING,
      citrus: NEW_THEME_TEXT_INPUT_PADDING,
      ketchupAndMustard: NEW_THEME_TEXT_INPUT_PADDING,
      lemonade: NEW_THEME_TEXT_INPUT_PADDING,
      forest: NEW_THEME_TEXT_INPUT_PADDING,
      watermelon: NEW_THEME_TEXT_INPUT_PADDING,
      area51: NEW_THEME_TEXT_INPUT_PADDING,
      polar: NEW_THEME_TEXT_INPUT_PADDING,
      glowInTheDark: NEW_THEME_TEXT_INPUT_PADDING,
      bubblegum: NEW_THEME_TEXT_INPUT_PADDING,
      millennial: NEW_THEME_TEXT_INPUT_PADDING,
      robot: NEW_THEME_TEXT_INPUT_PADDING,
      classic: CLASSIC_TEXT_INPUT_PADDING,
      coralReef: NEW_THEME_TEXT_INPUT_PADDING,
      mintChip: NEW_THEME_TEXT_INPUT_PADDING,
      lavender: NEW_THEME_TEXT_INPUT_PADDING,
      cherryVanilla: NEW_THEME_TEXT_INPUT_PADDING,
      berryPatch: NEW_THEME_TEXT_INPUT_PADDING,
      cucumber: NEW_THEME_TEXT_INPUT_PADDING,
      crushedVelvet: NEW_THEME_TEXT_INPUT_PADDING,
      playtime: NEW_THEME_TEXT_INPUT_PADDING,
      underTheSea: NEW_THEME_TEXT_INPUT_PADDING,
      blueAndGold: NEW_THEME_TEXT_INPUT_PADDING,
      blueSteel: NEW_THEME_TEXT_INPUT_PADDING,
      darkscheme: NEW_THEME_TEXT_INPUT_PADDING,
      twoTone: NEW_THEME_TEXT_INPUT_PADDING,
      pastel: NEW_THEME_TEXT_INPUT_PADDING,
      peachy: NEW_THEME_TEXT_INPUT_PADDING,
    },
  },
  dropdown: {
    backgroundColor: {
      type: 'color',
      default: '#FFFFFF',
      orange: '#FFFFFF',
      citrus: '#F7EC60',
      ketchupAndMustard: '#F9DD54',
      lemonade: '#5BB7E7',
      forest: '#A46C15',
      watermelon: '#FF8660',
      area51: '#362F49',
      polar: '#EFFAFF',
      glowInTheDark: '#D9FFD9',
      bubblegum: '#FF7CD0',
      millennial: '#FFFFFF',
      robot: '#B2D9EB',
      classic: '#1ABC9C',
      coralReef: '#FC766A',
      mintChip: '#A77D72',
      lavender: '#8875B1',
      cherryVanilla: '#A51928',
      berryPatch: '#DF6589',
      cucumber: '#52C794',
      crushedVelvet: '#69396D',
      playtime: '#6AA4FC',
      underTheSea: '#096A6A',
      blueAndGold: '#FFD662',
      blueSteel: '#353B51',
      darkscheme: '#B22D2D',
      twoTone: '#000000',
      pastel: '#C87FDB',
      peachy: '#FFA351',
    },
    textColor: {
      type: 'color',
      default: '#4D575F',
      orange: '#000000',
      citrus: '#000000',
      ketchupAndMustard: '#193A55',
      lemonade: '#FFFFFF',
      forest: '#FFFFFF',
      watermelon: '#151F00',
      area51: '#D8FFA7',
      polar: '#0094CA',
      glowInTheDark: '#000000',
      bubblegum: '#FFFFFF',
      millennial: '#442C2E',
      robot: '#353C42',
      classic: '#FFFFFF',
      coralReef: '#FDF995',
      mintChip: '#E9FCFF',
      lavender: '#FFFFFF',
      cherryVanilla: '#FFF5F5',
      berryPatch: '#FFFFFF',
      cucumber: '#EFFFF9',
      crushedVelvet: '#FFFFFF',
      playtime: '#FFFFFF',
      underTheSea: '#FFFFFF',
      blueAndGold: '#00539C',
      blueSteel: '#FFFFFF',
      darkscheme: '#FFFFFF',
      twoTone: '#FFFFFF',
      pastel: '#FFFFFF',
      peachy: '#FFFFFF',
    },
    borderColor: {
      type: 'color',
      default: '#000000',
      orange: '#000000',
      citrus: '#69883D',
      ketchupAndMustard: '#193A55',
      lemonade: '#ACCFDE',
      forest: '#482F08',
      watermelon: '#578B2E',
      area51: '#B394FF',
      polar: '#ACCFDE',
      glowInTheDark: '#5EFF5E',
      bubblegum: '#FFFFFF',
      millennial: '#442C2E',
      robot: '#80A7B9',
      classic: '#000000',
      coralReef: '#D75D52',
      mintChip: '#B1624E',
      lavender: '#CCB9E1',
      cherryVanilla: '#CECECC',
      berryPatch: '#FFDBE5',
      cucumber: '#EFFFF9',
      crushedVelvet: '#2D0A30',
      playtime: '#4B85DD',
      underTheSea: '#95DBE5',
      blueAndGold: '#D1D1D1',
      blueSteel: '#71788E',
      darkscheme: '#000000',
      twoTone: '#000000',
      pastel: '#D1F3DF',
      peachy: '#DF6C06',
    },
    borderRadius: {
      default: 4,
      orange: 0,
      citrus: 2,
      ketchupAndMustard: 5,
      lemonade: 6,
      forest: 6,
      watermelon: 20,
      area51: 10,
      polar: 20,
      glowInTheDark: 10,
      bubblegum: 20,
      millennial: 20,
      robot: 0,
      classic: 0,
      coralReef: 10,
      mintChip: 10,
      lavender: 10,
      cherryVanilla: 25,
      berryPatch: 30,
      cucumber: 30,
      crushedVelvet: 30,
      playtime: 10,
      underTheSea: 30,
      blueAndGold: 30,
      blueSteel: 30,
      darkscheme: 30,
      twoTone: 30,
      pastel: 30,
      peachy: 30,
    },
    borderWidth: {
      default: 1,
      orange: 2,
      citrus: 2,
      ketchupAndMustard: 0,
      lemonade: 0,
      forest: 2,
      watermelon: 4,
      area51: 2,
      polar: 2,
      glowInTheDark: 2,
      bubblegum: 2,
      millennial: 0,
      robot: 2,
      classic: 0,
      coralReef: 0,
      mintChip: 0,
      lavender: 0,
      cherryVanilla: 0,
      berryPatch: 0,
      cucumber: 1,
      crushedVelvet: 1,
      playtime: 2,
      underTheSea: 0,
      blueAndGold: 0,
      blueSteel: 0,
      darkscheme: 0,
      twoTone: 0,
      pastel: 0,
      peachy: 0,
    },
    fontFamily: {
      default: 'Arial',
      orange: 'Verdana',
      citrus: 'Georgia',
      ketchupAndMustard: 'Georgia',
      lemonade: 'Arial',
      forest: 'Verdana',
      watermelon: 'Georgia',
      area51: 'Arial Black',
      polar: 'Verdana',
      glowInTheDark: 'Tahoma',
      bubblegum: 'Georgia',
      millennial: 'Verdana',
      robot: 'Arial Black',
      classic: 'Arial',
      coralReef: 'Arial',
      mintChip: 'Verdana',
      lavender: 'Georgia',
      cherryVanilla: 'Trebuchet',
      berryPatch: 'Trebuchet',
      cucumber: 'Verdana',
      crushedVelvet: 'Verdana',
      playtime: 'Verdana',
      underTheSea: 'Trebuchet',
      blueAndGold: 'Trebuchet',
      blueSteel: 'Trebuchet',
      darkscheme: 'Trebuchet',
      twoTone: 'Trebuchet',
      pastel: 'Trebuchet',
      peachy: 'Verdana',
    },
    fontSize: STANDARD_FONT_SIZE_THEME_VALUES,
    padding: {
      default: NEW_THEME_DROPDOWN_PADDING,
      orange: NEW_THEME_DROPDOWN_PADDING,
      citrus: NEW_THEME_DROPDOWN_PADDING,
      ketchupAndMustard: NEW_THEME_DROPDOWN_PADDING,
      lemonade: NEW_THEME_DROPDOWN_PADDING,
      forest: NEW_THEME_DROPDOWN_PADDING,
      watermelon: NEW_THEME_DROPDOWN_PADDING,
      area51: NEW_THEME_DROPDOWN_PADDING,
      polar: NEW_THEME_DROPDOWN_PADDING,
      glowInTheDark: NEW_THEME_DROPDOWN_PADDING,
      bubblegum: NEW_THEME_DROPDOWN_PADDING,
      millennial: NEW_THEME_DROPDOWN_PADDING,
      robot: NEW_THEME_DROPDOWN_PADDING,
      classic: CLASSIC_DROPDOWN_PADDING,
      coralReef: NEW_THEME_DROPDOWN_PADDING,
      mintChip: NEW_THEME_DROPDOWN_PADDING,
      lavender: NEW_THEME_DROPDOWN_PADDING,
      cherryVanilla: NEW_THEME_DROPDOWN_PADDING,
      berryPatch: NEW_THEME_DROPDOWN_PADDING,
      cucumber: NEW_THEME_DROPDOWN_PADDING,
      crushedVelvet: NEW_THEME_DROPDOWN_PADDING,
      playtime: NEW_THEME_DROPDOWN_PADDING,
      underTheSea: NEW_THEME_DROPDOWN_PADDING,
      blueAndGold: NEW_THEME_DROPDOWN_PADDING,
      blueSteel: NEW_THEME_DROPDOWN_PADDING,
      darkscheme: NEW_THEME_DROPDOWN_PADDING,
      twoTone: NEW_THEME_DROPDOWN_PADDING,
      pastel: NEW_THEME_DROPDOWN_PADDING,
      peachy: NEW_THEME_DROPDOWN_PADDING,
    },
  },
  photoSelect: {
    backgroundColor: {
      type: 'color',
      default: '#FFA400',
      orange: '#4BC6D0',
      citrus: '#F7EC60',
      ketchupAndMustard: '#F9DD54',
      lemonade: '#5BB7E7',
      forest: '#A46C15',
      watermelon: '#FF8660',
      area51: '#362F49',
      polar: '#EFFAFF',
      glowInTheDark: '#D9FFD9',
      bubblegum: '#FF7CD0',
      millennial: '#442C2E',
      robot: '#B2D9EB',
      classic: '#1ABC9C',
      coralReef: '#FC766A',
      mintChip: '#A77D72',
      lavender: '#8875B1',
      cherryVanilla: '#A51928',
      berryPatch: '#DF6589',
      cucumber: '#52C794',
      crushedVelvet: '#69396D',
      playtime: '#FF7B70',
      underTheSea: '#096A6A',
      blueAndGold: '#FFD662',
      blueSteel: '#353B51',
      darkscheme: '#B22D2D',
      twoTone: '#000000',
      pastel: '#C87FDB',
      peachy: '#FFA351',
    },
    textColor: {
      type: 'color',
      default: '#FFFFFF',
      orange: '#FFFFFF',
      citrus: '#000000',
      ketchupAndMustard: '#193A55',
      lemonade: '#FFFFFF',
      forest: '#FFFFFF',
      watermelon: '#151F00',
      area51: '#D8FFA7',
      polar: '#0094CA',
      glowInTheDark: '#000000',
      bubblegum: '#FFFFFF',
      millennial: '#FFFFFF',
      robot: '#353C42',
      classic: '#FFFFFF',
      coralReef: '#FDF995',
      mintChip: '#E9FCFF',
      lavender: '#FFFFFF',
      cherryVanilla: '#FFF5F5',
      berryPatch: '#FFFFFF',
      cucumber: '#FFFFFF',
      crushedVelvet: '#FFFFFF',
      playtime: '#FFFFFF',
      underTheSea: '#FFFFFF',
      blueAndGold: '#00539C',
      blueSteel: '#FFFFFF',
      darkscheme: '#FFFFFF',
      twoTone: '#FFFFFF',
      pastel: '#FFFFFF',
      peachy: '#FFFFFF',
    },
    borderColor: {
      type: 'color',
      default: '#4D575F',
      orange: '#FFFFFF',
      citrus: '#69883D',
      ketchupAndMustard: '#193A55',
      lemonade: '#ACCFDE',
      forest: '#482F08',
      watermelon: '#578B2E',
      area51: '#B394FF',
      polar: '#ACCFDE',
      glowInTheDark: '#5EFF5E',
      bubblegum: '#FFFFFF',
      millennial: '#FFFFFF',
      robot: '#80A7B9',
      classic: '#000000',
      coralReef: '#FDF995',
      mintChip: '#D75D52',
      lavender: '#CCB9E1',
      cherryVanilla: '#CECECC',
      berryPatch: '#FFDBE5',
      cucumber: '#EFFFF9',
      crushedVelvet: '#2D0A30',
      playtime: '#DA5145',
      underTheSea: '#95DBE5',
      blueAndGold: '#D1D1D1',
      blueSteel: '#71788E',
      darkscheme: '#000000',
      twoTone: '#000000',
      pastel: '#D1F3DF',
      peachy: '#DF6C06',
    },
    borderRadius: {
      default: 4,
      orange: 0,
      citrus: 2,
      ketchupAndMustard: 5,
      lemonade: 6,
      forest: 6,
      watermelon: 20,
      area51: 10,
      polar: 20,
      glowInTheDark: 10,
      bubblegum: 20,
      millennial: 20,
      robot: 0,
      classic: 0,
      coralReef: 10,
      mintChip: 10,
      lavender: 10,
      cherryVanilla: 25,
      berryPatch: 30,
      cucumber: 30,
      crushedVelvet: 30,
      playtime: 10,
      underTheSea: 30,
      blueAndGold: 30,
      blueSteel: 30,
      darkscheme: 30,
      twoTone: 30,
      pastel: 30,
      peachy: 30,
    },
    borderWidth: {
      default: 1,
      orange: 2,
      citrus: 2,
      ketchupAndMustard: 0,
      lemonade: 0,
      forest: 2,
      watermelon: 4,
      area51: 2,
      polar: 2,
      glowInTheDark: 2,
      bubblegum: 2,
      millennial: 0,
      robot: 2,
      classic: 0,
      coralReef: 2,
      mintChip: 0,
      lavender: 0,
      cherryVanilla: 0,
      berryPatch: 0,
      cucumber: 1,
      crushedVelvet: 2,
      playtime: 2,
      underTheSea: 0,
      blueAndGold: 2,
      blueSteel: 2,
      darkscheme: 0,
      twoTone: 0,
      pastel: 0,
      peachy: 0,
    },
  },
  button: {
    backgroundColor: {
      type: 'color',
      default: '#FFA400',
      orange: '#4BC6D0',
      citrus: '#F7EC60',
      ketchupAndMustard: '#F9DD54',
      lemonade: '#5BB7E7',
      forest: '#A46C15',
      watermelon: '#FF8660',
      area51: '#362F49',
      polar: '#EFFAFF',
      glowInTheDark: '#D9FFD9',
      bubblegum: '#FF7CD0',
      millennial: '#442C2E',
      robot: '#B2D9EB',
      classic: '#1ABC9C',
      coralReef: '#FC766A',
      mintChip: '#A77D72',
      lavender: '#8875B1',
      cherryVanilla: '#A51928',
      berryPatch: '#DF6589',
      cucumber: '#52C794',
      crushedVelvet: '#69396D',
      playtime: '#FF7B70',
      underTheSea: '#096A6A',
      blueAndGold: '#FFD662',
      blueSteel: '#353B51',
      darkscheme: '#B22D2D',
      twoTone: '#000000',
      pastel: '#C87FDB',
      peachy: '#FFA351',
    },
    textColor: {
      type: 'color',
      default: '#FFFFFF',
      orange: '#FFFFFF',
      citrus: '#000000',
      ketchupAndMustard: '#193A55',
      lemonade: '#FFFFFF',
      forest: '#FFFFFF',
      watermelon: '#151F00',
      area51: '#D8FFA7',
      polar: '#0094CA',
      glowInTheDark: '#000000',
      bubblegum: '#FFFFFF',
      millennial: '#FFFFFF',
      robot: '#353C42',
      classic: '#FFFFFF',
      coralReef: '#FDF995',
      mintChip: '#E9FCFF',
      lavender: '#FFFFFF',
      cherryVanilla: '#FFF5F5',
      berryPatch: '#FFFFFF',
      cucumber: '#FFFFFF',
      crushedVelvet: '#FFFFFF',
      playtime: '#FFFFFF',
      underTheSea: '#FFFFFF',
      blueAndGold: '#00539C',
      blueSteel: '#FFFFFF',
      darkscheme: '#FFFFFF',
      twoTone: '#FFFFFF',
      pastel: '#FFFFFF',
      peachy: '#FFFFFF',
    },
    borderColor: {
      type: 'color',
      default: '#4D575F',
      orange: '#FFFFFF',
      citrus: '#69883D',
      ketchupAndMustard: '#193A55',
      lemonade: '#ACCFDE',
      forest: '#482F08',
      watermelon: '#578B2E',
      area51: '#B394FF',
      polar: '#ACCFDE',
      glowInTheDark: '#5EFF5E',
      bubblegum: '#FFFFFF',
      millennial: '#FFFFFF',
      robot: '#80A7B9',
      classic: '#000000',
      coralReef: '#FDF995',
      mintChip: '#D75D52',
      lavender: '#CCB9E1',
      cherryVanilla: '#CECECC',
      berryPatch: '#FFDBE5',
      cucumber: '#EFFFF9',
      crushedVelvet: '#2D0A30',
      playtime: '#DA5145',
      underTheSea: '#95DBE5',
      blueAndGold: '#D1D1D1',
      blueSteel: '#71788E',
      darkscheme: '#000000',
      twoTone: '#000000',
      pastel: '#D1F3DF',
      peachy: '#DF6C06',
    },
    borderRadius: {
      default: 4,
      orange: 0,
      citrus: 2,
      ketchupAndMustard: 5,
      lemonade: 6,
      forest: 6,
      watermelon: 20,
      area51: 10,
      polar: 20,
      glowInTheDark: 10,
      bubblegum: 20,
      millennial: 20,
      robot: 0,
      classic: 0,
      coralReef: 10,
      mintChip: 10,
      lavender: 10,
      cherryVanilla: 25,
      berryPatch: 30,
      cucumber: 30,
      crushedVelvet: 30,
      playtime: 10,
      underTheSea: 30,
      blueAndGold: 30,
      blueSteel: 30,
      darkscheme: 30,
      twoTone: 30,
      pastel: 30,
      peachy: 30,
    },
    borderWidth: {
      default: 1,
      orange: 2,
      citrus: 2,
      ketchupAndMustard: 0,
      lemonade: 0,
      forest: 2,
      watermelon: 4,
      area51: 2,
      polar: 2,
      glowInTheDark: 2,
      bubblegum: 2,
      millennial: 0,
      robot: 2,
      classic: 0,
      coralReef: 2,
      mintChip: 0,
      lavender: 0,
      cherryVanilla: 0,
      berryPatch: 0,
      cucumber: 1,
      crushedVelvet: 2,
      playtime: 2,
      underTheSea: 0,
      blueAndGold: 2,
      blueSteel: 2,
      darkscheme: 0,
      twoTone: 0,
      pastel: 0,
      peachy: 0,
    },
    fontFamily: {
      default: 'Arial Black',
      orange: 'Verdana',
      citrus: 'Georgia',
      ketchupAndMustard: 'Georgia',
      lemonade: 'Arial',
      forest: 'Verdana',
      watermelon: 'Georgia',
      area51: 'Arial Black',
      polar: 'Verdana',
      glowInTheDark: 'Tahoma',
      bubblegum: 'Georgia',
      millennial: 'Verdana',
      robot: 'Arial Black',
      classic: 'Arial',
      coralReef: 'Arial Black',
      mintChip: 'Verdana',
      lavender: 'Georgia',
      cherryVanilla: 'Trebuchet',
      berryPatch: 'Trebuchet',
      cucumber: 'Verdana',
      crushedVelvet: 'Verdana',
      playtime: 'Verdana',
      underTheSea: 'Trebuchet',
      blueAndGold: 'Trebuchet',
      blueSteel: 'Trebuchet',
      darkscheme: 'Trebuchet',
      twoTone: 'Trebuchet',
      pastel: 'Trebuchet',
      peachy: 'Verdana',
    },
    fontSize: {
      default: 15,
      orange: 15,
      citrus: 15,
      ketchupAndMustard: 15,
      lemonade: 15,
      forest: 15,
      watermelon: 15,
      area51: 15,
      polar: 15,
      glowInTheDark: 15,
      bubblegum: 15,
      millennial: 15,
      robot: 15,
      classic: 14,
      coralReef: 15,
      mintChip: 15,
      lavender: 15,
      cherryVanilla: 15,
      berryPatch: 15,
      cucumber: 15,
      crushedVelvet: 15,
      playtime: 15,
      underTheSea: 15,
      blueAndGold: 15,
      blueSteel: 15,
      darkscheme: 15,
      twoTone: 15,
      pastel: 15,
      peachy: 15,
    },
  },
  textArea: {
    backgroundColor: {
      type: 'color',
      default: '#F2F2F2',
      orange: '#4D3100',
      citrus: '#FFFFFF',
      ketchupAndMustard: '#FFFFFF',
      lemonade: '#FFFFFF',
      forest: '#FFD18A',
      watermelon: '#E2F0AA',
      area51: '#221D30',
      polar: '#0094CA',
      glowInTheDark: '#262B2F',
      bubblegum: '#FFFFFF',
      millennial: '#FEEAE6',
      robot: '#F5F5F6',
      classic: '#FFFFFF',
      coralReef: '#FDF995',
      mintChip: '#4EB4C2',
      lavender: '#CCB9E1',
      cherryVanilla: '#F1E2D4',
      berryPatch: '#FFDBE6',
      cucumber: '#EFFFF9',
      crushedVelvet: '#2D0A30',
      playtime: '#3EE061',
      underTheSea: '#95DBE5',
      blueAndGold: '#D1D1D1',
      blueSteel: '#71788E',
      darkscheme: '#707070',
      twoTone: '#FFFFFF',
      pastel: '#D1F3DF',
      peachy: '#FBEFB4',
    },
    textColor: {
      type: 'color',
      default: '#4D575F',
      orange: '#FFFFFF',
      citrus: '#000000',
      ketchupAndMustard: '#193A55',
      lemonade: '#00A8FF',
      forest: '#482F08',
      watermelon: '#151F00',
      area51: '#C4ABFF',
      polar: '#EFFAFF',
      glowInTheDark: '#D9FFD9',
      bubblegum: '#000000',
      millennial: '#442C2E',
      robot: '#353C42',
      classic: '#000000',
      coralReef: '#5BA0ED',
      mintChip: '#E5F4F6',
      lavender: '#5E4D83',
      cherryVanilla: '#A51928',
      berryPatch: '#3C1053',
      cucumber: '#209864',
      crushedVelvet: '#FFFFFF',
      playtime: '#FFFFFF',
      underTheSea: '#096A6A',
      blueAndGold: '#00539C',
      blueSteel: '#FFFFFF',
      darkscheme: '#FFFFFF',
      twoTone: '#000000',
      pastel: '#A065AF',
      peachy: '#DF6C06',
    },
    borderColor: {
      type: 'color',
      default: '#FFFFFF',
      orange: '#FFFFFF',
      citrus: '#69883D',
      ketchupAndMustard: '#193A55',
      lemonade: '#193A55',
      forest: '#000000',
      watermelon: '#578B2E',
      area51: '#C4ABFF',
      polar: '#FFFFFF',
      glowInTheDark: '#FFFFFF',
      bubblegum: '#000000',
      millennial: '#FFFFFF',
      robot: '#80A7B9',
      classic: 'rgb(153, 153, 153)',
      coralReef: '#D75D52',
      mintChip: '#D75D52',
      lavender: '#CECECC',
      cherryVanilla: '#CECECC',
      berryPatch: '#CECECC',
      cucumber: '#209864',
      crushedVelvet: '#69396D',
      playtime: '#18BC3C',
      underTheSea: '#096A6A',
      blueAndGold: '#FFD662',
      blueSteel: '#4B526B',
      darkscheme: '#000000',
      twoTone: '#000000',
      pastel: '#C87FDB',
      peachy: '#CECECC',
    },
    borderRadius: {
      default: 2,
      orange: 2,
      citrus: 4,
      ketchupAndMustard: 5,
      lemonade: 6,
      forest: 5,
      watermelon: 20,
      area51: 20,
      polar: 8,
      glowInTheDark: 0,
      bubblegum: 8,
      millennial: 8,
      robot: 0,
      classic: 0,
      coralReef: 10,
      mintChip: 10,
      lavender: 10,
      cherryVanilla: 5,
      berryPatch: 30,
      cucumber: 30,
      crushedVelvet: 5,
      playtime: 10,
      underTheSea: 30,
      blueAndGold: 30,
      blueSteel: 30,
      darkscheme: 30,
      twoTone: 30,
      pastel: 30,
      peachy: 30,
    },
    borderWidth: {
      default: 1,
      orange: 0,
      citrus: 0,
      ketchupAndMustard: 2,
      lemonade: 0,
      forest: 0,
      watermelon: 0,
      area51: 0,
      polar: 2,
      glowInTheDark: 0,
      bubblegum: 0,
      millennial: 0,
      robot: 1,
      classic: 1,
      coralReef: 0,
      mintChip: 0,
      lavender: 0,
      cherryVanilla: 0,
      berryPatch: 0,
      cucumber: 0,
      crushedVelvet: 1,
      playtime: 0,
      underTheSea: 0,
      blueAndGold: 0,
      blueSteel: 0,
      darkscheme: 1,
      twoTone: 1,
      pastel: 0,
      peachy: 0,
    },
    fontFamily: {
      default: 'Arial',
      orange: 'Arial',
      citrus: 'Palatino',
      ketchupAndMustard: 'Tahoma',
      lemonade: 'Arial',
      forest: 'Arial',
      watermelon: 'Georgia',
      area51: 'Trebuchet',
      polar: 'Arial',
      glowInTheDark: 'Tahoma',
      bubblegum: 'Trebuchet',
      millennial: 'Arial',
      robot: 'Tahoma',
      classic: 'Arial',
      coralReef: 'Arial',
      mintChip: 'Verdana',
      lavender: 'Georgia',
      cherryVanilla: 'Trebuchet',
      berryPatch: 'Trebuchet',
      cucumber: 'Verdana',
      crushedVelvet: 'Verdana',
      playtime: 'Verdana',
      underTheSea: 'Trebuchet',
      blueAndGold: 'Trebuchet',
      blueSteel: 'Trebuchet',
      darkscheme: 'Trebuchet',
      twoTone: 'Trebuchet',
      pastel: 'Trebuchet',
      peachy: 'Verdana',
    },
    fontSize: STANDARD_FONT_SIZE_THEME_VALUES,
    padding: {
      default: NEW_THEME_TEXT_AREA_PADDING,
      orange: NEW_THEME_TEXT_AREA_PADDING,
      citrus: NEW_THEME_TEXT_AREA_PADDING,
      ketchupAndMustard: NEW_THEME_TEXT_AREA_PADDING,
      lemonade: NEW_THEME_TEXT_AREA_PADDING,
      forest: NEW_THEME_TEXT_AREA_PADDING,
      watermelon: NEW_THEME_TEXT_AREA_PADDING,
      area51: NEW_THEME_TEXT_AREA_PADDING,
      polar: NEW_THEME_TEXT_AREA_PADDING,
      glowInTheDark: NEW_THEME_TEXT_AREA_PADDING,
      bubblegum: NEW_THEME_TEXT_AREA_PADDING,
      millennial: NEW_THEME_TEXT_AREA_PADDING,
      robot: NEW_THEME_TEXT_AREA_PADDING,
      classic: CLASSIC_TEXT_AREA_PADDING,
      coralReef: NEW_THEME_TEXT_AREA_PADDING,
      mintChip: NEW_THEME_TEXT_AREA_PADDING,
      lavender: NEW_THEME_TEXT_AREA_PADDING,
      cherryVanilla: NEW_THEME_TEXT_AREA_PADDING,
      berryPatch: NEW_THEME_TEXT_AREA_PADDING,
      cucumber: NEW_THEME_TEXT_AREA_PADDING,
      crushedVelvet: NEW_THEME_TEXT_AREA_PADDING,
      playtime: NEW_THEME_TEXT_AREA_PADDING,
      underTheSea: NEW_THEME_TEXT_AREA_PADDING,
      blueAndGold: NEW_THEME_TEXT_AREA_PADDING,
      blueSteel: NEW_THEME_TEXT_AREA_PADDING,
      darkscheme: NEW_THEME_TEXT_AREA_PADDING,
      twoTone: NEW_THEME_TEXT_AREA_PADDING,
      pastel: NEW_THEME_TEXT_AREA_PADDING,
      peachy: NEW_THEME_TEXT_AREA_PADDING,
    },
  },
};

export default themeValues;
